import { Controller } from "@hotwired/stimulus"

// Handles dismissible alerts
export default class extends Controller {
  dismiss() {
    this.element.remove()
  }
}